import { create } from "zustand";
import { find } from "../services/service";
export const useGlobalStore = create((set) => ({
  loading: false,
  data: [],
  operateur: [],
  error: null,
  operateurs: async (url) => {
    set({
      loading: true,
      operateur: [],
    });

    try {
      const getItems = await find(url);
      set({
        loading: false,
        operateur: getItems.data,
        error: null
      });
    } catch (error) {
      set({
        loading: false,
        operateur: [],
        error: error?.response?.data?.donnee,
      });
    }
  },
  getData: async (url) => {
    set({
      loading: true,
      data: [],
    });

    try {
      const getItems = await find(url);
      set({
        loading: false,
        data: getItems.data,
        error: null
      });
    } catch (error) {
      set({
        loading: false,
        data: [],
        error: error?.response?.data?.donnee,
      });
    }
  },
}));
